import { Row } from "react-bootstrap";
import fieldSection from "../../../formJsonData/Purchase/PurchaseListing/PurchasingForm.json";
import { useState } from "react";
import { handlePOCreatByItems } from "../commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";
import { useNavigate } from "react-router-dom";

const SubTableListPopup = ({
  setIsViewOpen,
  selectedItems,
  selectedRow,
  setIsOverlayLoader,
  getAllListingData
}) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  let actualFields = fieldSection?.sections?.[1]?.tabs?.[0]?.rows?.[0]?.filter(
    (field) =>
      [
        "prd_item_code_text",
        "prd_item_description",
        "prd_tech_specification",
        "prd_quantity",
        "prd_uom",
      ].includes(field?.name),
  );
  const getValue = (fieldName, singleData) => {
    if (fieldName == "prd_item_code_text") {
      return singleData?.item_details?.item_rm_code || "";
    }
    return singleData[fieldName];
  };
  const onTableActionChange = (e, row) => {
    const { checked } = e.target;

    setFormData((prev) => {
      const prevRows = prev?.selectedTableRows || [];

      const updatedRows = checked
        ? [...new Set([...prevRows, row.prd_id])] // prevent duplicates
        : prevRows.filter((id) => id !== row.prd_id);

      return {
        selectedTableRows: updatedRows,
      };
    });
  };

  return (
    <div className="popupSearchContainerBG po-custom-creation">
      <div className="popupInwardModal popupWidthAdjustmentParamDetails renderListSub-popup">
        <div className="rejectSearchCross">
          <button
            onClick={() => setIsViewOpen(false)}
            className="nonNativeButton2"
            aria-label="Reject Button"
          >
            <i className="bi bi-x-lg h4"></i>
          </button>
        </div>
        <Row className="autoWidthImportant sampleverification-table">
          <h2 className="modalHeader">Item Details</h2>
          <table className="table table-white responsive borderless no-wrap mt-3 align-middle renderTable">
            <thead>
              <tr>
                <th>#</th>
                <th>Sr. No.</th>
                {actualFields?.map((field, fieldIndex) => {
                  return <th key={`field-${fieldIndex}`}>{field.label}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {selectedItems &&
                selectedItems.map((singleData, rowIndex) => (
                  <tr key={"rowIndex" + rowIndex} className="border-top">
                    <td>
                      {singleData.fk_po_id ? null : <input
                        type="checkbox"
                        onChange={(e) => {
                          onTableActionChange(e, singleData);
                        }}
                      />}
                    </td>
                    <td>{rowIndex + 1}</td>
                    {actualFields?.map((field, fieldIndex) => {
                      return (
                        <td key={`field-${fieldIndex}`}>
                          {getValue(field.name, singleData)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
            </tbody>
          </table>
        </Row>
        <div className="popupInwardButtonsContainer">
          <div className="popupSearchButtons">
            <button type="button" onClick={() => setIsViewOpen(false)}>
              Cancel
            </button>
            <button
              type="button"
              onClick={() =>
                handlePOCreatByItems(
                  {
                    fk_req_id: selectedItems?.[0]?.fk_req,
                    po_status: "Saved",
                    po_prd_items: formData?.selectedTableRows,
                  },
                  setIsOverlayLoader,
                  getAllListingData,
                  setIsViewOpen,
                  selectedRow
                )
              }
              disabled={
                !formData?.selectedTableRows ||
                formData?.selectedTableRows?.length === 0
              }
            >
              Create PO
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SubTableListPopup;
